"use client";

import { add } from "@amplitude/analytics-browser";
import type {
  EnrichmentPlugin,
  Event
} from "@amplitude/analytics-browser/lib/esm/types";

import {
  APPLICATION_ID,
  ENVIRONMENT,
  SURFACE_ID,
  SURFACE_TYPE
} from "./surface";

/**
 * Registers the enrichment plugin that stamps surface identity on every event
 * this app emits, autocapture included. Kept apart from ./surface so that
 * middleware and server actions can import the constants without pulling the
 * browser SDK into an Edge bundle.
 */
let registered = false;

export function ensureSurfacePlugin() {
  if (registered) return;
  registered = true;

  const plugin: EnrichmentPlugin = {
    name: "shield-surface",
    type: "enrichment",
    execute: async (event: Event) => {
      event.event_properties = {
        surface_id: SURFACE_ID,
        surface_type: SURFACE_TYPE,
        application_id: APPLICATION_ID,
        emitter: "client",
        environment: ENVIRONMENT,
        // An explicit per-call value wins: a component that knows it runs on
        // the hosted checkout can say so without a second plugin.
        ...event.event_properties
      };
      return event;
    }
  };

  add(plugin);
}
